import { render, staticRenderFns } from "./CourseColumn.vue?vue&type=template&id=1a0034c5"
import script from "./CourseColumn.vue?vue&type=script&lang=js"
export * from "./CourseColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports